import { t } from 'ttag';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import DataLoading from 'components/layouts/LoadingViews/DataLoading.js';
import CoreLayout from 'components/layouts/CoreLayout/index.js';
import SpareParts from 'views/unauthenticated/Forms/SpareParts/index.js';
import NotFound from 'views/unauthenticated/NotFound/index.js';
import 'styles/base.scss';

export const ROUTES = [
    {
        element: <CoreLayout />,
        children: [
            // eslint-disable-next-line max-len
            { path: '/', element: <SpareParts />, handle: { getTitle: () => t`(BROWSER_TAB_TITLE)_UNAUTHED_PARTS_FORM` } },
            { path: '*', element: <NotFound />, handle: { getTitle: () => t`(BROWSER_TAB_TITLE)_NOT_FOUND` } },
        ],
    },
];

export const router = createBrowserRouter(ROUTES);

const ELVSearchRouter = () => (
    <DataLoading show={useSelector(s => s.layout.loading)}>
        <RouterProvider router={router} />
    </DataLoading>
);

export default ELVSearchRouter;
